<template>
  <div class="subtitle-2 pb-2">
    <router-link to="/websites/">
      {{ breadcrumbsData.root }}
    </router-link>
    <span> / </span>
    <router-link :to="breadcrumbsData.hostingPlanPath">
      {{ breadcrumbsData.hostingPlan }} ({{ breadcrumbsData.rootDomain }})
    </router-link>
    <span v-show="breadcrumbsData.domain"> / </span>
    {{ breadcrumbsData.domain }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HostingBreadcrumbs',
  props: {
    managedItemName: {
      type: String,
      required: true
    },
    hostingid: {
      required: true,
      type: [String, Number],
    },
  },
  computed: {
    ...mapGetters(['hosting']),
    breadcrumbsData () {
      return {
        root: 'Websites',
        hostingPlan: this.hosting.name,
        rootDomain: this.hosting.domain,
        hostingPlanPath: this.hostingPlanPath,
        domain: this.managedItemName
      }
    },
    hostingPlanPath () {
      switch (this.hosting.groupname) {
        case 'Shared Hosting':
          return `/hosting/shared/${this.hostingid}`
        case 'Reseller Hosting':
          return `/hosting/reseller/${this.hostingid}`
        case 'Virtual Private Server':
          return `/servers/mvm/${this.hostingid}`
        case 'Dedicated Server':
          return `/hosting/dedicated/${this.hostingid}`
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
